module.exports = __webpack_public_path__ + "static/media/Hochzeitseinladung-3.c06561d3.png";